import { create } from 'zustand';
// import { useLettersCountStore } from './getLettersCountStore';
import { ApiUtils } from '@shared/utils';
import { LettersApi } from '@shared/api';

interface UseViewLetterStore {
  data?: Blob;
  loading: boolean;
  error: string | null;
  viewLetter: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useViewLetterStore = create<UseViewLetterStore>((set) => ({
  loading: false,
  data: undefined,
  error: null,

  viewLetter: async (id, signal) => {
    try {
      set({ loading: true, data: undefined, error: null });
      const result = await LettersApi.viewLetter(id, signal);
      set({ loading: false, data: result.data ?? '' });
      // useLettersCountStore.getState().get();
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  },

  clear: () => set({ loading: false, data: undefined, error: null }),
}));
